// removed by extract-text-webpack-plugin
module.exports = {"class-one-container":"class-one-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","icon-info-circled":"icon-info-circled","sort-by":"sort-by","sort-by-label":"sort-by-label","createBtn":"createBtn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ClassOne/ClassOne.scss
// module id = DeMY
// module chunks = 0